<style scoped>
    .vue-modal {
        display: block;
    }
</style>

<template>
    <div style="display:inline-block;width:100%">
        <div id="status_changer">
            <div v-if="update_permission">
                <button @click="confirmHistories()" class="btn btn-primary btn-sm">
                    <span v-show="!show_loader" v-text="trans('confirm_selected_items')"></span>
                    <div class="la-ball-fall" v-show="show_loader"><div></div><div></div><div></div></div>
                </button>
            </div>
        </div>
    </div>
</template>


<script>

    let Functions = require("../../Functions");

    export default {
        props: ['current_route', 'update_permission', 'translations'],
        mounted: function() {
            Vue.http.headers.common['X-CSRF-TOKEN'] = document.querySelector('#token').getAttribute('content');
        },
        data: function () {
            return {
                checked: [],
                show_loader: false,
            };
        },
        methods: {
            trans(name, path = 'stock') {
                return Functions.trans(this.translations, name, path);
            },
            confirmHistories: function () {
                if (this.checked.length === 0) {
                    return this.itemsNotFound();
                }
                if(confirm(this.trans('to_confirm_history'))) {
                    this.updateStatuses(this.item_id);
                }
            },
            updateStatuses: function () {
                this.show_loader = true;
                let obj = this;
                this.$http.post(this.current_route + '/confirm_many', {ids: this.checked})
                    .then(() => {
                        obj.checked = [];
                        obj.show_loader = false;
                        this.$root.$emit('update-table');
                    }).catch(() => {
                        obj.show_loader = false;
                        alert(this.trans('error.cannot_be_confirmed'));
                });
            },
            itemsNotFound: function () {
                alert(this.trans('to_confirm_history'));
            }
        },
        //EVENTS
        created: function () {
            this.$root.$on('update:checked', (val) => {this.checked = val});
        }
    }
</script>
